export var PROPERTY_CARD_APPEARANCES = Object.freeze({
  LARGE: 'large',
  SMALL: 'small',
  HORIZONTAL: 'horizontal',
  FLAG: 'flag'
});
export var PROPERTY_CARD_BADGE_APPEARANCES = Object.freeze({
  DEFAULT: 'default',
  NOTIFICATION: 'notification',
  ZILLOW: 'zillow'
});